<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>参数设置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row>
        <el-col :span="24">
          <el-form
            ref="formParamRef"
            :model="formParam"
            :rules="formParamRules"
            label-width="120px"
          >
            <el-form-item label="可推荐作品数" prop="RecWorksNum">
              <el-input
                v-model="formParam.RecWorksNum"
                placeholder="请输入可推荐作品数"
                style="width: 200px"
              ></el-input>
              <span class="inputtext"
                >用于设置学校会员中心可推荐的项目作品个数</span
              >
            </el-form-item>
            <el-form-item label="可提交作品数" prop="ReferWorksNum">
              <el-input
                v-model="formParam.ReferWorksNum"
                placeholder="请输入可提交作品数"
                style="width: 200px"
              ></el-input>
              <span class="inputtext"
                >用于设置个人会员中心同一赛道可提交的项目作品个数</span
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    // 可推荐作品数正则
    var isNumber = (rule, value, cb) => {
      if (value <= 0) {
        cb(new Error('不能小于0'))
      } else if (value > 10) {
        cb(new Error('不能大于10'))
      } else if (!/^[0-9]*$/.test(value)) {
        cb(new Error('只能输入数字'))
      } else {
        cb()
      }
    }
    return {
      formParam: {
        RecWorksNum: '',
        ReferWorksNum: ''
      },
      formParamRules: {
        RecWorksNum: [
          {
            required: true,
            message: '请输入可推荐作品数',
            trigger: 'blur'
          },
          {
            validator: isNumber,
            trigger: 'blur'
          }
        ],
        ReferWorksNum: [
          {
            required: true,
            message: '请输入可提交作品数',
            trigger: 'blur'
          },
          {
            validator: isNumber,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    this.getNum()
  },
  methods: {
    // 回填
    async getNum() {
      const { data: res } = await this.$http.get(
        '/api/ParameterSetting/GetParameterSetting'
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.formParam = res.Data.parameterSetting
    },
    // 保存
    onSubmit() {
      this.$refs.formParamRef.validate(async (valid) => {
        if (!valid) return false
        const { data: res } = await this.$http.post(
          '/api/ParameterSetting/SaveParameterSetting',
          this.formParam
        )
        if (res.StatusCode !== 1) return console.log(res.Msg)
        this.$message.success(res.Msg)
        this.getNum()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.inputtext {
  color: #999;
  margin-left: 10px;
}
</style>
